const productAttrInit = () => {
  // General
  const singleAttr: NodeListOf<HTMLElement> = document.querySelectorAll(
    ".single-product-attr"
  );
  const selects: NodeListOf<HTMLSelectElement> =
    document.querySelectorAll(".variations select");
  const tooltips: NodeListOf<HTMLElement> = document.querySelectorAll(
    ".product-options__tooltip"
  );

  // Functions
  const activeItem = (item: HTMLElement) => {
    // Remove all active from same row
    const parent = item.closest(".single-product-attr-group");
    const items = parent.querySelectorAll(".single-product-attr--active");
    [...items].forEach((theitem) => {
      theitem.classList.remove("single-product-attr--active");
    });

    // Add active statement on current item
    item.classList.add("single-product-attr--active");
  };

  const disableItems = (items: NodeListOf<HTMLElement>) => {
    [...items].forEach((item) => {
      const attr = item.dataset.attr as string;
      const slug = item.dataset.slug as string;

      const select = document.getElementById(attr) as HTMLSelectElement;
      const option = select.querySelector(
        `option[value="${slug}"]`
      ) as HTMLSelectElement;

      if (option?.innerHTML.includes("- sold out")) {
        item.classList.add("single-product-attr--disabled");
      } else {
        item.classList.remove("single-product-attr--disabled");
      }
    });
  };

  const closeAllTooltips = (items: NodeListOf<HTMLElement>) => {
    [...items].forEach((item) => {
      const tooltipContent = item.querySelector(
        ".product-options__tooltip-content"
      ) as HTMLElement;
      const tooltipArrow = item.querySelector(
        ".product-options__tooltip-arrow"
      ) as HTMLDivElement;

      if (tooltipContent) {
        tooltipContent.classList.remove(
          "product-options__tooltip-content--active"
        );
        tooltipContent.style.marginLeft = "0px";
        tooltipArrow.style.marginLeft = "0px";
      }
    });
  };

  setInterval(() => {
    // Check if items should be disabled
    disableItems(singleAttr);
  }, 200);

  [...singleAttr].forEach((item) => {
    item.addEventListener("click", () => {
      // Active item
      activeItem(item);
      disableItems(singleAttr);
    });
  });

  // Load through all the tooltips
  tooltips.forEach((tooltip) => {
    const tooltipSpan = tooltip.querySelector("span") as HTMLSpanElement;
    const tooltipContent = tooltip.querySelector(
      ".product-options__tooltip-content"
    ) as HTMLDivElement;
    const tooltipArrow = tooltip.querySelector(
      ".product-options__tooltip-arrow"
    ) as HTMLDivElement;

    let tooltipEventListener = "click";

    if (window.screen.width > 767) {
      tooltipEventListener = "mouseover";
    }

    tooltipSpan.addEventListener(tooltipEventListener, () => {
      if (tooltipContent) {
        if (
          !tooltipContent.classList.contains(
            "product-options__tooltip-content--active"
          )
        ) {
          closeAllTooltips(tooltips);

          // Check if it's outside the window.
          const windowWidth = document.documentElement.clientWidth as number;
          const tooltipContentWidth =
            tooltipContent.getBoundingClientRect().width;
          const tooltipContentPosition =
            tooltipContent.getBoundingClientRect().left;
          let difference = 0;

          if (tooltipContentPosition + tooltipContentWidth > windowWidth) {
            difference =
              tooltipContentPosition + tooltipContentWidth - windowWidth + 12;
          }

          tooltipContent.style.marginLeft = `-${difference}px`;
          tooltipArrow.style.marginLeft = `${difference}px`;
          tooltipContent.classList.add(
            "product-options__tooltip-content--active"
          );
        } else {
          tooltipContent.classList.remove(
            "product-options__tooltip-content--active"
          );
          tooltipContent.style.marginLeft = "0px";
          tooltipArrow.style.marginLeft = "0px";
        }
      }
    });

    if (window.screen.width > 767) {
      tooltipContent?.addEventListener("mouseleave", () => {
        closeAllTooltips(tooltips);
      });
    }
  });

  window.addEventListener("scroll", () => {
    closeAllTooltips(tooltips);
  });

  window.addEventListener("resize", () => {
    closeAllTooltips(tooltips);
  });

  [...selects].forEach((select) => {
    const selectName = select.id;
    const activeOption = select.value;
    const attributes: NodeListOf<HTMLElement> = document.querySelectorAll(
      `.single-product-attr[data-attr="${selectName}"]`
    );

    [...attributes].forEach((item) => {
      if (item.dataset.slug === activeOption) {
        item.classList.add("single-product-attr--active");
      }
    });
  });
};

export default productAttrInit;
